import { invalidateClientCache } from './client-cache';
import { clearAllOrderCache, invalidateOrderCache } from './order-cache';
import { clearAllProjectListCache, invalidateClientProjectLists } from './project-list-cache';
import { firstPositiveNumber } from './cache-utils';

export const invalidateClientDataCache = (clientId?: number): void => {
  if (clientId) {
    invalidateClientCache(clientId);
    invalidateClientProjectLists(clientId);
    return;
  }

  invalidateClientCache();
  clearAllProjectListCache();
};

export const invalidateRoomDataCache = (clientId?: number): void => {
  invalidateClientDataCache(clientId);
};

export const invalidateProjectDataCache = (clientId?: number): void => {
  if (clientId) {
    invalidateClientProjectLists(clientId);
    return;
  }

  clearAllProjectListCache();
};

export const invalidateOrderDataCache = (orderId?: number, clientId?: number): void => {
  if (orderId) {
    invalidateOrderCache(orderId);
  } else {
    clearAllOrderCache();
  }

  invalidateProjectDataCache(clientId);
};

export const resolveClientId = (...sources: any[]): number | undefined => {
  for (const source of sources) {
    const clientId = firstPositiveNumber(
      source,
      source?.clientId,
      source?.client?.id,
      source?.project?.clientId,
      source?.payload?.clientId,
      source?.payload?.client?.id,
      source?.data?.clientId,
      source?.data?.client?.id,
      source?.stateObj?.draperyOrder?.clientId,
      source?.copyState?.draperyOrder?.clientId,
      source?.data?.stateObj?.draperyOrder?.clientId,
      source?.data?.copyState?.draperyOrder?.clientId
    );

    if (clientId) {
      return clientId;
    }
  }

  return undefined;
};

export const resolveOrderId = (...sources: any[]): number | undefined => {
  for (const source of sources) {
    const orderId = firstPositiveNumber(
      source,
      source?.draperyOrderId,
      source?.orderId,
      source?.itemId,
      source?.draperyOrder?.id,
      source?.payload?.draperyOrderId,
      source?.payload?.orderId,
      source?.payload?.itemId,
      source?.data?.draperyOrderId,
      source?.data?.orderId,
      source?.data?.itemId,
      source?.stateObj?.draperyOrder?.id,
      source?.copyState?.draperyOrder?.id,
      source?.data?.stateObj?.draperyOrder?.id,
      source?.data?.copyState?.draperyOrder?.id
    );

    if (orderId) {
      return orderId;
    }
  }

  return undefined;
};
